// extracted by mini-css-extract-plugin
module.exports = {"activeOption":"lv","option":"lw","phone":"lx","value":"ly","text":"lz","label":"lA","list":"lB","centerMenu":"lC","active":"lD"};